module.exports = "/_next/static/images/c94b2218ebf060aa169c668fef0f2a72-holding-card-vertical@2x.png";